import { WeixinPayController } from "./controller/weixin.pay.controller";
import { UnionPayController } from "./controller/union.pay.controller";
import { PayOperatorResolver } from "./resolver/pay.operator.resolver";
import { PayOperatorService } from "./service/pay.operator.service";
import { AliPayController } from "./controller/ali.pay.controller";
import { WeixinPayResolver } from "./resolver/weixin.pay.resolver";
import { WeixinPayConfig } from "./model/weixin.pay.config.entity";
import { UnionPayConfig } from "./model/union.pay.config.entity";
import { UnionPayResolver } from "./resolver/union.pay.resolver";
import { WeixinPayService } from "./service/weixin.pay.service";
import { UnionPayService } from "./service/union.pay.service";
import { AliPayResolver } from "./resolver/ali.pay.resolver";
import { AliPayConfig } from "./model/ali.pay.config.entity";
import { ConfigResolver } from "./resolver/config.resolver";
import { AliPayService } from "./service/ali.pay.service";
import { ConfigService } from "./service/config.service";
import { PayResolver } from "./resolver/pay.resolver";
import { TypeOrmModule } from "@nestjs/typeorm";
import { RandomUtil } from "./util/random.util";
import { VerifyUtil } from "./util/verify.util";
import { FileUtil } from "./util/file.util";
import { DateUtil } from "./util/date.util";
import { SignUtil } from "./util/sign.util";
import { HttpUtil } from "./util/http.util";
import { XmlUtil } from "./util/xml.util";
import { Pay } from "./model/pay.entity";
import { Module } from "@nestjs/common";

@Module({
    imports: [TypeOrmModule.forFeature([Pay, WeixinPayConfig, AliPayConfig, UnionPayConfig])],
    providers: [
        RandomUtil, HttpUtil, SignUtil, VerifyUtil, XmlUtil, DateUtil, FileUtil,
        ConfigService, ConfigResolver,
        AliPayService, WeixinPayService, UnionPayService,
        AliPayResolver, WeixinPayResolver, UnionPayResolver,
        PayOperatorService, PayOperatorResolver,
        PayResolver
    ],
    controllers: [AliPayController, WeixinPayController, UnionPayController],
})
export class PayModule { }
